import { api } from '@api/api2';

export const getRenters = () => api.v4('get', 'rent/resident/list');
